// extracted by mini-css-extract-plugin
module.exports = {"root":"_3doHW","itemMeta":"_3X-YD","ratingAndSalesGrid":"_24GHy","price":"_22AMM","gridPrice":"tZyd2","cartButton":"_1vl5N"};